import { GENERATE_FLASHCARDS_FAILURE, GENERATE_FLASHCARDS_SUCCESS } from "./flashcards.actionTypes";


const initialState = {
 cards: null,
 message: ""
};

export const flashcardsReducer = (state = initialState, action) => {
  switch (action.type) {

    case GENERATE_FLASHCARDS_SUCCESS:
      return {
        ...state,
        cards: action.payload,
      };
    case GENERATE_FLASHCARDS_FAILURE:
      return {
        ...state,
        message: "",
      };

    default:
      return state;
  }
};
